<template>
  <div>
    <div class="skeleton column" v-for="i in itens" :key="i" :class="[{dark:dark},classItem]" :style="{width: largura ? largura : '100%', height: altura ? altura : '100%'}">
      <div class="sombra" :style="{'animation-duration': velocidade + 's','animation-delay': (atraso * i + ( 0.15 * i)) + 's'}"></div>
    </div>
  </div>
</template>
<script>
export default {
  components: {
  },
  props: {
    classItem: {
      type: String,
      description: "As classes de cada item",
    },
    largura: {
      type: String,
      description: "Largura do container",
    },
    altura: {
      type: String,
      description: "Altura do container",
    },
    dark: {
      type: Boolean,
      default: false,
      description: "Para ser usado com fundos escuros",
    },
    velocidade: {
      type: Number,
      default: 2,
      description: "Velocidade da animação em segundos",
    },
    itens: {
      type: Number,
      default: 1,
      description: "Quantidade de itens iguais",
    },
    atraso: {
      type: Number,
      default: 0,
      description: "Velocidade do atraso para cada item (o atraso soma, para criar uma animação fluída. 0: sem atraso",
    }
  },
  data() {
    return {
    };
  }
};
</script>
<style scoped>
.skeleton{
  background: rgba(0,0,0,0.05);
  display: flex;
  overflow: hidden;
}
.skeleton .sombra{
  content: "";
  width: 100%;
  height: 100%;
  display: flex;
  animation: passar infinite linear;
  background: -moz-linear-gradient(left,  rgba(0,0,0,0) 0%, rgba(0,0,0,0) 25%, rgba(0,0,0,0.1) 50%, rgba(0,0,0,0) 75%, rgba(0,0,0,0) 100%);
  background: -webkit-linear-gradient(left,  rgba(0,0,0,0) 0%,rgba(0,0,0,0) 25%,rgba(0,0,0,0.1) 50%,rgba(0,0,0,0) 75%,rgba(0,0,0,0) 100%);
  background: linear-gradient(to right,  rgba(0,0,0,0) 0%,rgba(0,0,0,0) 25%,rgba(0,0,0,0.1) 50%,rgba(0,0,0,0) 75%,rgba(0,0,0,0) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00000000', endColorstr='#00000000',GradientType=1 );
}
.skeleton.dark{
  background: rgba(255,255,255,0.2);
}
.skeleton.dark .sombra{
  background: -moz-linear-gradient(left,  rgba(255,255,255,0) 0%, rgba(255,255,255,0) 25%, rgba(255,255,255,0.1) 50%, rgba(255,255,255,0) 75%, rgba(255,255,255,0) 100%);
  background: -webkit-linear-gradient(left,  rgba(255,255,255,0) 0%,rgba(255,255,255,0) 25%,rgba(255,255,255,0.1) 50%,rgba(255,255,255,0) 75%,rgba(255,255,255,0) 100%);
  background: linear-gradient(to right,  rgba(255,255,255,0) 0%,rgba(255,255,255,0) 25%,rgba(255,255,255,0.1) 50%,rgba(255,255,255,0) 75%,rgba(255,255,255,0) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00ffffff', endColorstr='#00ffffff',GradientType=1 );
}
@keyframes passar{
  0%{
    transform: translate(-100%, 0)
  }
  100%{
    transform: translate(100%, 0)
  }
}
</style>